import React, { useContext, useEffect, useState } from "react";
import axiosInstance from "../../../services/axiosInstance";
import Header from "../../header";
import InstructorSidebar from "../sidebar";
import { AppContext } from "../../../services/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import { publicationdetail } from "../../../services/publicationService";
import { buildPublicationPath } from "../../../utils/slugify";

const UserFavoritePublications = () => {
  const [favorites, setFavorites] = useState([]);
  const [loading, setLoading] = useState(true);
  const [publicationDetails, setPublicationDetails] = useState({});
  const { auth } = useContext(AppContext);
  const token = auth.token;
  const navigate = useNavigate();

  // Favori yayınları çek
  useEffect(() => {
    const fetchFavorites = async () => {
      try {
        const response = await axiosInstance.get(
          "http://89.163.221.52:8080/idealonline/v1/userpanel/favoritepublicationsListByUserId/1",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setFavorites(response.data.data || []);
      } catch (error) {
        console.error("Favori yayınlar alınamadı:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchFavorites();
  }, []);

  // Yayın detaylarını çek
  useEffect(() => {
    const fetchDetails = async () => {
      const details = {};
      for (let fav of favorites) {
        const pubId = fav.publication?.id;
        if (pubId && !details[pubId]) {
          try {
            const response = await publicationdetail(pubId, token);
            details[pubId] = response?.data?.elasticjson || {};
          } catch (error) {
            console.error(`Yayın ${pubId} detay alınamadı`, error);
          }
        }
      }
      setPublicationDetails(details);
    };

    if (favorites.length > 0) {
      fetchDetails();
    }
  }, [favorites, token]);

  // Detaylardan "Başlık", "Yazar" gibi değerleri çek
  const getAttributeValue = (pubId, attributeName) => {
    const details = publicationDetails[pubId];
    const attr = details?.publicationtypeInfo?.find(
      (a) => a.attributename === attributeName
    );
    return attr?.value?.[0]?.value?.[0] ?? "-";
  };

  return (
    <div className="main-wrapper mt-5">
      <Header />
      <div className="breadcrumb-bar breadcrumb-bar-info">
        <div className="container">
          <div className="row">
            <div className="col-md-12 col-12">
              <div className="breadcrumb-list">
                <h2 className="breadcrumb-title">Favori Yayınlarım</h2>
                <nav aria-label="breadcrumb" className="page-breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/">Ana Sayfa</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Favori Yayınlarım
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="page-content">
        <div className="container">
          <div className="row">
            <InstructorSidebar />

            <div className="col-xl-9 col-lg-9">
              <div className="settings-widget card-details">
                <div className="settings-menu p-0">
                  <div className="profile-heading">
                    <h3>Favori Yayınlarım</h3>
                  </div>
                  {loading ? (
                    <p>Yükleniyor...</p>
                  ) : (
                    <div className="table-responsive custom-table">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>Başlık</th>
                            <th>Tür</th>
                            <th>Yazar</th>
                            <th>PDF</th>

                          </tr>
                        </thead>
                        <tbody>
                          {favorites.map((item) => {
                            const pubId = item.publication?.id;
                            return (
                              <tr
                                key={item.id}
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  navigate(buildPublicationPath({ title: getAttributeValue(pubId, "Başlık"), id: pubId }))
                                }
                              >
                                <td>
                                  {getAttributeValue(pubId, "Başlık")}
                                </td>
                                <td>{item.publication?.publicationtype?.name}</td>
                                <td>{getAttributeValue(pubId, "Yazar")}</td>
                                <td>
                                  {item.publication?.pdffile ? (
                                    <a
                                      href={`https://idealonline.com.tr/service/idealonline/v1/publications/search/displayFile/${item.publication.id}/${item.publication.pdffile}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      onClick={(e) => e.stopPropagation()}
                                    >
                                      PDF
                                    </a>
                                  ) : (
                                    "-"
                                  )}
                                </td>

                              </tr>
                            );
                          })}
                          {favorites.length === 0 && (
                            <tr>
                              <td colSpan="5">Favori yayınız bulunmamaktadır.</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default UserFavoritePublications;
